import * as pu from 'pansx-utils';

export class Validation extends pu.Validation {
    public static passWorldRules(pwd: string): boolean | string{
        const regExp = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z`~!@#%&\\\-_=\];:'",<>]{8,20}$/
// 特殊字符：  `~!@#$%^&*()-_=+\|[\{}];:'",<.>/?
// 要求：6-18位，必须同时包含小写字母、大写字母、数字和特殊字符
        if (regExp.test(pwd)){
            return true;
        }else {
            return '要求：8-20位，必须同时包含小写字母、大写字母、数字';
        }
    }
    public static registeredCapital(a: string): boolean | string{
        const regExp =/^[0-9.]*$/;
        if(regExp.test(a)){
            return  true
        }else {
            return '注册资本仅为数字'
        }

    }

    public static organizationName(o: string): boolean | string{
        const regExp =/^[0-9A-Z]*$/;
        if(regExp.test(o)){
            return  true
        }else {
            return '社会信用代码为数字和大写字母'
        }

    }


}
